const TEAM_MANAGEMENT_MENU_ACTIONS = {
  PROSPECT: { label: 'Prospect', value: 'prospect' },
  ADMIN: { label: 'Admin', value: 'admin' },
  RESEND_INVITE: { label: 'Resend Invite', value: 'resend' },
  REMVOVE_USER: { label: 'Remove User', value: 'remove' },
};
/* eslint-disable react/react-in-jsx-scope */
const CYBER_CONSTANT = {
  SUBHEADER: {
    HEADER: 'Cybersecurity Business Value Benchmark',
    SUBHEADER_1: 'Measures the protection levels of important cybersecurity controls as compared to peers.',
    COMPARISION: 'Comparison group: ',
  },
  VIEW: {
    CURRENT: 'CURRENT',
    TARGET: 'TARGET',
  },
  STATES: {
    NOT_ANSWERED: 'NOT_ANSWERED',
    LEADING: 'LEADING',
    MID_LEADING: 'MID_LEADING',
    MID_RANGE: 'MID_RANGE',
    MID_LAGGING: 'MID_LAGGING',
    LAGGING: 'LAGGING',
  },
  STATES_LABEL: {
    NOT_ANSWERED: 'Not avail',
    LEADING: 'Leading',
    MID_LEADING: 'Mid-Leading',
    MID_RANGE: 'Mid-Range',
    MID_LAGGING: 'Mid-Lagging',
    LAGGING: 'Lagging',
  },
  BUTTON: {
    EDIT: 'Edit',
    EDIT_GROUP: 'Edit Comparison Group',
    SUMBIT: 'Submit',
    CANCEL: 'Cancel',
    AGREE_BUTTON: 'Agree & Continue',
    APPLY: 'Apply',
    HELP: 'Help',
  },
  LABEL: {
    CURRENT: 'Current',
    TARGET: 'Target',
    ISCURRENT: 'isCurrent',
    ISTARGET: 'isTarget',
    ISCHECK: 'isCheck',
    CURRENT_ACTUAL: 'Current (Actual)',
    CONTEXT: 'Context',
    DEFINITION: 'Definitions',
    RECOMMENDED_RESOURCES: 'Recommended Resources',
    PEER_DISCUSSIONS: 'Peer Discussions',
    RECOMMENDED_TOOLS: 'Recommended Tools',
    WHATS_NEXT: "What's next for you",
    CLOCK: 'Clock',
    CALCULATION: 'Calculation',
    CHECKBOX_TEXT: 'Mark Current as a "rough estimate"',
    SAVE: 'Save',
    CHN: 'cn',
    UNSAVED_TITLE: 'Saving Changes',
    UNSAVED: 'Your inputs are not saved. Are you sure you want to exit?',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    PRINT_PAGE: 'Print Page',
    RESULTS: 'Results',
    MY_ORG: 'My Org',
    TOP_PEER: ['Top Peer (75', <sup key="sup-1">th</sup>, ' %)'],
    MID_PEER: ['Mid Peer (50', <sup key="sup-2">th</sup>, ' %)'],
    BOTTOM_PEER: ['Bottom Peer (25', <sup key="sup-3">th</sup>, ' %)'],
    MID_PERCENTILE: '25th to 75th Percentile',
    MEDIAN: 'Median',
    EXIT: 'Exit',
    SAVED: 'Changes are saved successfully!',
    ENTER_CURRENT_TARGET_VALUE: 'Enter a current value and a target value (above) to graph',
    ENTER_TARGET_VALUE: 'Enter a target value (above) to graph',
    ENTER_CURRENT_VALUE: 'Enter a current value (above) to graph',
    BENCHMARK_COMPARISON_GROUP_TITLE: 'Edit Benchmark Comparison Group',
    BENCHMARK_COMPARISON_GROUP_SUBTITLE: 'Choose filters below. (Minimum n size = 7)',
    LAST_UPDATED_AT: 'Last updated:',
    LAST_UPDATED_ON: 'Last updated',
    INDUSTRYCOHORT: 'Industry',
    REVENUECOHORT: 'Revenue Size',
    REGIONCOHORT: 'Region',
    INDUSTRY_COHORT_KEY: 'industryCohort',
    REVENUE_COHORT_KEY: 'revenueCohort',
    REGION_COHORT_KEY: 'headquarterCohort',
    HEADQUARTERCOHORT: 'Headquarter Location',
    FILTER_BY: 'Filter By',
    ADD_A_SECOND_FILTER: 'Add a second filter',
    SELECT_ALL: 'Select All',
    DESELECT_ALL: 'Deselect All',
    CLEAR_FILTERS: 'Clear Filters',
    SELECTED: 'selected',
    NSIZE_TOO_SMALL: 'There are not enough selections for a benchmark. Add more to proceed.',
    OVERALL: 'Overall',
    SELECT_A_FILTER: 'Select a filter on the left to get started.',
    METRIC_VIEW: 'Metric',
    PEER: 'Peer',
    NOT_AVAILABLE: 'Not avail',
    CURRENT_VALUE: 'Current Value',
    TARGET_VALUE: 'Target Value',
    CURRENT_PERCENTILE: 'Current Percentile',
    TARGET_PERCENTILE: 'Target Percentile',
    BENCHMARK_HIDE_FOR_NO_RESPONSE: 'Response not provided',
    BENCHMARK_HIDE_FOR_NO_VALUE: 'Benchmark will show when minimum n size is reached.',
    VIEW_LESS: 'Hide Metric Definition',
    VIEW_MORE: 'View Metric Definition',
    MY_ORG_STATUS: 'My Org Status',
    MY_ORG_PERCENTILE: 'My Org Percentile',
    MY_ORG_LAST: 'My Org value(s) last updated: ',
    MY_ORG_STATUS_EXPLANATION: 'My Org Status: Org percentile as compared to median',
    BOTTOM: 'Bottom',
    MID: 'Mid',
    TOP: 'Top',
    ACCESS_KPI: 'Access Removal Time',
    DOWNLOAD: 'Download',
    RESULT_NOT_AVAILABLE: 'Results are avaialble when at least 1 current metric is submitted',
    GENERATING_POWERPOINT: 'Generating Powerpoint',
    EST: '(est.)',
    ESTIMATE: 'estimate',
    RESOURCE_NOTE: 'Resources available per your current Gartner subscription.',
    ASSIGN_TEAM: 'Assign Team',
    MANAGE_TEAM: 'Manage Team',
    BENCHMARK_VIEW: 'Benchmark View',
    BENCHMARK_NA: 'BENCHMARK NOT AVAILABLE',
    READJUST: 'Adjust Filters',
    NSIZE: 'N Size',
    ORG_NAME: 'Organization:',
    ROLE: 'Role:',
    CREATED_BY: 'Created by:',
    SWITCH_DASH: 'Switch Dashboard',
    DASHBOARD: 'Dashboard',
    AVAILABLE: 'Available',
    UN_AVAILABLE: 'Unavailable',
    UNKNOWN: 'Unknown',
    BENCHMARK: 'Benchmark',
    LOCKED: 'Benchmark Locked',
    GET_BENCHMARK: 'Get Benchmark',
    VIEW_INSIGHTS: 'View Insights',
    UNLOCKED_BENCH: 'Unlocked Benchmarks',
    ADJUST_PEERS: 'Adjust your peer group to view benchmark',
    THRESHOLD_VAL: '< 7',
    SHOW_MANAGE_LIST: 1,
    KPI_CARDS: 16,
    PEER_COMPARIONS: 'Benchmark Comparison Group:',
    CURRENT_BENCHMARK: 'currentBenchmark',
    TARGET_BENCHMARK: 'targetBenchmark',
    LABEL_TYPES: ['Leading', 'Mid-Leading', 'Mid-Range', 'Mid-Lagging', 'Lagging'],
    ENTIRE_DATASET: 'Entire Dataset',
    BENCHMARK_CURRENT: 'benchmarkCurrentStatus',
    BENCHMARK_TARGET: 'benchmarkTargetStatus',
  },
  DIALOG: {
    HEADER1: 'Confirm Organization Details',
    HEADER2: 'Change Your Organization Details',
    SUBHEADER: 'Industry, sub-industry and organization size are based on the information in your Gartner.com profile as available. Please confirm or update for the organization/entity you want to assess.',
    selectedIndustry: {
      TITLE: 'Industry',
    },
    selectedSubIndustry: {
      TITLE: 'Sub-industry',
    },
    selectedRevenue: {
      TITLE: 'Organization Size',
      SUBHEADER: 'Select a revenue range.',
      HELPER: `Banks: Enter "total interest income plus non-interest income minus provision for loan losses."
Insurance companies: Enter "gross written premiums plus other income."
Government or non-profit organizations: enter "operating budget"`,
      tooltipVal: false,
      showTooltip: true,
    },
    selectedHeadquarter: {
      TITLE: 'Headquarters Location',
      SUBHEADER: 'Search the location where most of the corporate business functions operate.',
      tooltipVal: false,
      showTooltip: true,
    },
    REQUIRED: 'All fields are required.*',
  },
  UPDATE_DIALOG: {
    TITLE: 'Quarterly Data Update Is Available',
    TEXT1: 'Keep your dashboard current by ',
    TEXT2: 'accepting the latest benchmark ',
    TEXT3: 'update (as of ',
    TEXT4: 'Accepting the latest benchmark does the following:',
    TEXT5: '* Updates your charts with the latest benchmarks and ',
    TEXT6: 'cannot be undone.',
    TEXT7: '* Takes a snapshot of your org’s metrics for the quarter (to support future trend views in your report).',
    TEXT8: 'Not ready? You may opt to Cancel and update your org metrics first and/or download a copy of your existing report before choosing to accept the update.',
    BUTTON1: 'Cancel',
    BUTTON2: 'Update',
  },
  EDIT_PRIORITY_DIALOG: {
    TITLE: 'Edit Priority Kpi(s)',
    SUBHEADER: 'You can select upto 5 kpi(s)',
    BUTTON1: 'Cancel',
    BUTTON2: 'Save',
  },
  OPT_DIALOG: {
    HEADER: 'Opt In Agreement',
    SUBHEADER_1: 'Agreement',
    SUBHEADER_2: 'Additional Information',
    TEXT_1: 'You will be contributing information about your organization.',
    TEXT_2: 'As a Gartner client or invited participant, your inputs help shape the insights this Gartner tool provides to you and your peers. By completing an assessment, you agree that your responses may be used by Gartner, in an aggregate and non-identifiable format (neither you nor your organization are identifiable), for future research purposes in the ordinary course of our business in accordance with ',
    TEXT_3: "Gartner's Privacy Policy.",
    TEXT_4: 'Gartner will not disclose confidential information submitted via this assessment to a non-agent third party except when required to do so by law. We use appropriate security controls to protect the information you provide, and where applicable, will take reasonable steps to permit you to correct, amend, or delete information that is inaccurate or incomplete.',
    TEXT_5: 'Gartner products and services are subject to certain sanctions laws. As a result, prohibited individuals, as defined by law, those located in certain sanctioned countries or in locations where Gartner has chosen not to do business (including Cuba, Iran, North Korea, Russia, Sudan, Syria and the Crimean region in Ukraine), are not authorized to use this survey.',
    TEXT_6: 'By continuing to the assessment, you agree to these terms.',
    CHINESE_1: 'Gartner has no intention to collect any Important Data or Core Data. If you choose to enter information into this Gartner tool, you represent and warrant that you comply with all applicable laws, regulations and have received all necessary authorization and consents to interact with Gartner, and to disclose any and all information you may share with Gartner. Gartner 无意收集任何重要数据和核心数据。如您选择将信息输入至Gartner该工具，您在此声明并保证，您与Gartner互动以及您向Gartner披露分享任何及所有信息，均已获得所有必要的授权和同意，且遵守了所有适用的法律法规。',
    CHINESE_2: 'Use of Gartner tools shall be on the basis that you shall not disclose any Important Data or Core Data to Gartner. At the same time, you acknowledge and warrant that you will not disclose to Gartner any of the following information: 使用Gartner工具的前提基础是：您不会向Gartner披露任何重要数据和核心数据。同时，您亦确认并保证不会向Gartner披露任何下列信息：',
    CHINESE_3: 'a. state secrets, trade secrets or other similar non-public information, including any information or documents prohibited from disclosure by applicable laws, regulations, guidelines or other governmental or internal policies or procedures of your company; or',
    CHINESE_4: 'b. any information, intelligence or other documents, data, materials and items that may have a bearing on the national security or national interests of China.',
    CHINESE_5: 'a. 国家秘密、商业秘密或其他类似的非公开信息，包括适用的法律、法规、指南、政府的或贵公司内部的其他政策或程序所禁止披露的任何信息或文件；和',
    CHINESE_6: 'b. 任何可能关系中国国家安全和利益的信息、情报，或其他文件、数据、资料及物品。',
  },
  ACTIS: {
    EDIT_ICON: {
      activityAction: 'Edit_Icon',
      activityCategory: 'Action',
      activityMeta: 'User clicks on Edit icon of Comparision group',
      activityValue: 'true',
    },
    FILTER_AGREE: {
      activityAction: 'Filter_Agree',
      activityCategory: 'Action',
      activityMeta: 'User clicks on Agree & Continue button of Confirm your Organization dialog',
    },
    FILTER_CANCEL: {
      activityAction: 'Filter_Cancel',
      activityCategory: 'Action',
      activityMeta: 'User clicks on Cancel button of Confirm your Organization dialog',
      activityValue: 'true',
    },
    DRAWER_OPEN: {
      activityAction: 'Drawer_Open',
      activityCategory: 'Action',
    },
    DRAWER_CLOSE: {
      activityAction: 'Drawer_Close',
    },
    CONTEXT_ACCORDION_OPEN: {
      activityAction: 'Context_Accordion_Open',
      activityCategory: 'Action',
      activityMeta: 'User opens context accordion in drawer',
      activityValue: 'true',
    },
    CONTEXT_ACCORDION_CLOSE: {
      activityAction: 'Context_Accordion_Close',
      activityCategory: 'Action',
      activityMeta: 'User opens context accordion in drawer',
      activityValue: 'false',
    },
    COMPARISON_FILTER_APPLY: {
      activityAction: 'Comparison_Filter_Apply',
      activityCategory: 'Action',
      activityMeta: 'User applies filter for comparison filter',
      activityValue: 'true',
    },
    COMPARISON_FILTER_DIALOG_OPEN: {
      activityAction: 'Comparison_Filter_Dialog_Open',
      activityCategory: 'Action',
      activityMeta: 'User opens comparison filter dialog',
      activityValue: 'true',
    },
    COMPARISON_FILTER_CANCEL: {
      activityAction: 'Comparison_Filter_Cancel',
      activityCategory: 'Action',
      activityMeta: 'User cancel the selection for comparison filter',
    },
    COMPARISON_FILTER_SELECT_FIRST_FILTER: {
      activityAction: 'Comparison_Filter_Select_First_Fiter',
      activityCategory: 'Action',
      activityMeta: 'User selects the first comparison filter',
      activityValue: 'true',
    },
    COMPARISON_FILTER_START_ON_SECOND: {
      activityAction: 'Comparison_Filter_Start_On_Second',
      activityCategory: 'Action',
      activityMeta: 'User start to select second filter',
      activityValue: 'true',
    },
    COMPARISON_FILTER_SELECT_SECOND_FILTER: {
      activityAction: 'Comparison_Filter_Select_Second_Fiter',
      activityCategory: 'Action',
      activityMeta: 'User selects the second comparison filter',
    },
    COMPARISON_FILTER_CLEAR_SELECTIONS: {
      activityAction: 'Comparison_Filter_Clear_Selections',
      activityCategory: 'Action',
      activityMeta: 'User clears all the comparison filter selections',
    },
    COMPARISON_FILTER_DESELECT_ALL: {
      activityAction: 'Comparison_Filter_Deselect_All',
      activityCategory: 'Action',
    },
    COMPARISON_FILTER_SELECT_ALL: {
      activityAction: 'Comparison_Filter_Select_All',
      activityCategory: 'Action',
    },
    TOGGLE_TO_TARGET_VIEW: {
      activityAction: 'Toggle_To_Target_View',
      activityCategory: 'Action',
      activityMeta: 'User toggles to target view',
      activityValue: 'true',
    },
    TOGGLE_TO_CURRENT_VIEW: {
      activityAction: 'Toggle_To_Current_View',
      activityCategory: 'Action',
      activityMeta: 'User toggles to current view',
      activityValue: 'true',
    },
    DOWNLOAD_CYBER_REPORT: {
      activityAction: 'Download_Cyber_Report',
      activityCategory: 'Action',
      activityMeta: 'User clicks on download cyber report',
      activityValue: 'true',
    },
    RECOMMENDED_RESOURCES: {
      activityAction: 'Recommended_Resources',
      activityCategory: 'Link',
    },
    RECOMMENDED_RESOURCES_MAIN_PAGE: {
      activityAction: 'Recommended_Resources_Main_Page',
      activityCategory: 'Link',
    },
    RECOMMENDED_TOOLS: {
      activityAction: 'Recommended_Tools',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Recommended Tools link of CSVB',
    },
    INTERCOM_ICON_OPEN: {
      activityAction: 'Intercom_Icon_Open',
      activityMeta: 'User click on Intercom icon at the bottom',
      activityCategory: 'Action',
      activityValue: 'true',
    },
    INTERCOM_ICON_CLOSE: {
      activityAction: 'Intercom_Icon_Close',
      activityMeta: 'User clicks on Intercom icon at the bottom',
      activityCategory: 'Action',
      activityValue: 'true',
    },
    INTERCOM_HELP: {
      activityAction: 'Intercom_Header',
      activityMeta: 'User clicks on the Intercom Help button from header',
      activityCategory: 'Action',
      activityValue: 'true',
    },
    SENDS_INVITE: {
      activityAction: 'Sends_Invite',
      activityMeta: 'User clicks on Send invite button to invite',
      activityValue: 'true',
    },
    REMOVES_MEMBER: {
      activityAction: 'Removes_Member',
      activityMeta: 'User clicks on Remove user button to remove',
      activityValue: 'true',
    },
    RESENDS_INVITE: {
      activityAction: 'Resends_Invite',
      activityMeta: 'User clicks on resend invite button',
      activityValue: 'true',
    },
    UPDATE_ROLE: {
      activityAction: 'Update_Role',
      activityMeta: 'User clicks on update role button to update role to',
      activityValue: 'true',
    },
    SWITCH_DASHBOARD: {
      activityAction: 'Switch_Dashboard',
      activityMeta: 'User clicks on Switch Dashboard Button',
      activityCategory: 'Action',
      activityValue: 'true',
    },
    SELECT_DASHBOARD: {
      activityAction: 'Select_Dashboard',
      activityCategory: 'Action',
    },
    SELECT_UNLOCKED: {
      activityAction: 'Select_Unlocked',
      activityMeta: 'User selects Unlocked Benchmarks Categories',
      activityCategory: 'Action',
    },
    DESELECT_UNLOCKED: {
      activityAction: 'Deselect_Unlocked',
      activityMeta: 'User deselects Unlocked Benchmarks Categories',
      activityCategory: 'Action',
    },
    MANAGE_ACCESS_OPEN: {
      activityAction: 'Manage_Access_Open',
      activityMeta: 'User clicks on Manage access/Assign Team button to open drawer',
      activityCategory: 'Action',
      activityValue: 'true',
    },
    PEER_DISCUSSIONS: {
      activityAction: 'Peer_Discussions',
      activityCategory: 'Link',
    },
  },
  TREND_CHART: {
    LINE_1: 'For this metric, values for improvement trend ',
    LINE_2: 'n = ',
    LINE_3: 'As of ',
    LINE_4: 'Source: Gartner Benchmarks',
    SEE_BELOW: ' (see below table for more reference)',
  },
  TREND_DIRECTION: {
    HIGHER: 'higher',
    LOWER: 'lower',
  },
  DROPDOWN_ITEM: 'dropdownItem',
  MINIMUM_NSIZE_TO_SHOW_VALUE_IN_CHART: 10,
  LEGENDS: [
    {
      label: '0-25',
      state: 'LAGGING',
    },
    {
      label: '26-44',
      state: 'MID_LAGGING',
    },
    {
      label: '45-55',
      state: 'MID_RANGE',
    },
    {
      label: '56-74',
      state: 'MID_LEADING',
    },
    {
      label: '75-100',
      state: 'LEADING',
    },
  ],
  DD_DATE_FORMAT: 'DD MMM YYYY',
  DO_DATE_FORMAT: 'do MMMM yyyy',
  RR_TEXT_LIMIT: 120,
  LAST_MODIFIED_LIMIT: 15,
  RR_DOCUMENT: 'Document',
  GARTNER_NAME: 'Gartner',
  INPUT_LIMIT: 7,
  TEAM_MANAGEMENT: {
    TITLE: 'Assign Team Members',
    RESEND_INVITE: 'Resend Invite',
    REMOVE_USER: 'Remove User',
    PENDING: 'Pending',
    EXPIRED: 'Expired',
    ADD: 'Send Invite',
    ROLE: 'Role',
    EMAIL_ERROR_MESSAGE: 'Enter a valid work email address',
    ADD_INVITE_NOTES: 'Add Note',
    INVITE_PLACEHOLDER: 'Type your message...',
    OPTIONAL: '(Optional)',
    EMAIL_PLACEHOLDER: 'Enter Email Address',
    FIRST_NAME_PLACEHOLDER: 'Enter First Name',
    LAST_NAME_PLACEHOLDER: 'Enter Last Name',
    EMAIL: 'Work Email Address',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    INVALID_EMAIL: 'Please Enter valid Email id*',
    EMPTY_EMAIL: 'Email address is a mandatory field*',
    EMPTY_NAME: 'First Name is a mandatory field*',
    RESEND_SUCCESS_MESSAGE: 'Resend Notification Triggered',
    DEFAULT_ROLE: TEAM_MANAGEMENT_MENU_ACTIONS.PROSPECT,
    TEAM_MANAGEMENT_DRAWER_SUBTITLE: 'Assign Managers or Contributors (as per your permissions) to help you update the dashboard on a quarterly basis.',
    LEARN_ABOUT_USER_ROLE: 'Learn about roles and permissions',
    USER_ROLE_DESCRIPTION_1: 'The Cybersecurity Business Value Benchmark offers three roles: <b>Owner, Manager</b> and <b>Contributor</b>.',
    USER_ROLE_DESCRIPTION_2: 'The entitled client who starts the dashboard is always the Owner who can start the team collaboration.',
    ROLES_TABLE_TITLE: 'Team Roles from Most to Least Permissions',
    ADMIN_USER_ROLE: 'Admin User Role - ',
    TABLE_DATA_HEADER: [
      {
        id: 'rowHeader',
        label: '',
      },
      {
        id: 'haveGartnerLicense',
        label: 'Must have a Gartner license?',
      },
      {
        id: 'viewEditMetrics',
        label: 'View and Edit Metrics',
      },
      {
        id: 'viewOnlineCharts',
        label: 'View Results',
      },
      {
        id: 'changePeerDownload',
        label: 'Change Peer Comparision Group and Download Report',
      },
      {
        id: 'inviteToCollab',
        label: 'Invite Others to Collaborate',
      },
    ],
    TABLE_DATA_BODY: [
      {
        rowHeader: 'Owner',
        haveGartnerLicense: 'Yes',
        viewEditMetrics: 'Yes',
        viewOnlineCharts: 'Yes',
        changePeerDownload: 'Yes',
        inviteToCollab: 'Yes - Managers, Contributors',
      },
      {
        rowHeader: 'Manager',
        haveGartnerLicense: 'No',
        viewEditMetrics: 'Yes',
        viewOnlineCharts: 'Yes',
        changePeerDownload: 'Yes',
        inviteToCollab: 'Yes - Contributors',
      },
      {
        rowHeader: 'Contributor',
        haveGartnerLicense: 'No',
        viewEditMetrics: 'Yes',
        viewOnlineCharts: 'Yes',
        changePeerDownload: 'No',
        inviteToCollab: 'No',
      },
    ],
    INVITATION_REQUIRED: {
      HEADER: 'Invitation Verification Required',
      EMAIL: '##EMAIL##',
      INVITEE_EMAIL: '##INVITEE_EMAIL##',
      BODY: `We noticed the email domain for this team member is different.
      Your email domain is “@##INVITEE_EMAIL##” and you are inviting a collaborator from “@##EMAIL##”. Gartner CyberSecurity Business Value Benchmark is only licensed for employees within your organization.
      By clicking "Verify invitation and send," you are certifying the person being invited is an employee of your organization per our licensing requirements.`,
      VERIFY_AND_SEND: 'Verify and Send',
      CANCEL: 'Cancel',
    },
    DROPDOWN_ITEM: {
      MANAGER: 'Manager',
      CONTRIBUTOR: 'Contributor',
      REMOVE_USER: 'Remove User',
    },
    ROLES: {
      OWNER: 'Owner',
      MANAGER: 'Manager',
      CONTRIBUTOR: 'Contributor',
    },
    ALL_ROLES: [
      TEAM_MANAGEMENT_MENU_ACTIONS.PROSPECT, TEAM_MANAGEMENT_MENU_ACTIONS.ADMIN,
    ],
    MENU_ACTIONS: {
      admin_pending: [
        TEAM_MANAGEMENT_MENU_ACTIONS.PROSPECT,
        TEAM_MANAGEMENT_MENU_ACTIONS.ADMIN,
        TEAM_MANAGEMENT_MENU_ACTIONS.RESEND_INVITE,
        TEAM_MANAGEMENT_MENU_ACTIONS.REMVOVE_USER,
      ],
      admin_accepted: [
        TEAM_MANAGEMENT_MENU_ACTIONS.REMVOVE_USER,
      ],
      ae_pending: [
        TEAM_MANAGEMENT_MENU_ACTIONS.RESEND_INVITE,
        TEAM_MANAGEMENT_MENU_ACTIONS.REMVOVE_USER,
      ],
      ae_accepted: [
        TEAM_MANAGEMENT_MENU_ACTIONS.REMVOVE_USER,
      ],
      admin_expired: [
        TEAM_MANAGEMENT_MENU_ACTIONS.RESEND_INVITE,
        TEAM_MANAGEMENT_MENU_ACTIONS.REMVOVE_USER,
      ],
      ae_expired: [
        TEAM_MANAGEMENT_MENU_ACTIONS.RESEND_INVITE,
        TEAM_MANAGEMENT_MENU_ACTIONS.REMVOVE_USER,
      ],
    },
    ERROR_MESSAGES: {
      NON_BUSINESS_EMAIL: 'Please use a company-issued email address. Gmail, Yahoo, and other free email services are not accepted.',
      ALREADY_INVITED_USER: 'This team member is already invited to this dashboard.',
    },
    RESPONSES: {
      ADD_INVITE_ERROR: 'Failed to add! Please try again later',
      RESEND_INVITE_ERROR: 'Failed to resend invite! Please try again later',
      REMOVE_INVITE_ERROR: 'Failed to remove user! Please try again later',
      PROSPECT_DAYS_ERROR: 'Failed to skip campaign needs! Please try again later',
      UPDATE_ROLE_ERROR: 'Failed to update role! Please try again later',
      ADD_INVITE_SUCCESS: 'Invitation sent successfully',
      RESEND_INVITE_SUCCESS: 'Re-Invite sent successfully',
      REMOVE_INVITE_SUCCESS: 'Member removed successfully',
      SKIP_PROSPECT_ERROR: 'Failed to skip campaign needs! Please try again later',
      UPDATE_ROLE_SUCCESS: 'Role updated successfully',
    },
  },
  INTERCOM: {
    DELAY: 3000,
    APP_ID: 'i2xr1x2j',
    HELP_ROUTE: 'https://intercom.help/outcome-driven-metrics',
  },
  DROPDOWN: {
    SELECTED: 'Selected',
    ALL_SELECTED: 'All Selected',
    SELECT: 'Select...',
    SELECT_ALL: 'Select All',
  },
};
export default CYBER_CONSTANT;
